import "react-phone-number-input/style.css";
import "./styles/phone-input-styles.css";

import PhoneInputWithCountrySelect, {
  type ExternalValue,
  type Value,
} from "react-phone-number-input";
import type { ReactNode } from "react";
import { Text } from "../common/typography";

export function PhoneInput({
  value,
  onChange,
  disabled = false,
  required,
  error,
  rightIcon,
  label,
  className = "",
  labelInfo,
}: {
  value?: Value | ExternalValue;
  onChange(value?: Value): void;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  rightIcon?: ReactNode;
  label?: string;
  className?: string;
  labelInfo?: string;
}) {
  return (
    <div className="relative w-full">
      {label ? (
        <div className="mb-2 flex items-center gap-1.5 px-1.5">
          <Text variant="bodySmBold" tone="body" inline>
            {label}
            {required ? <span className="ml-0.5 text-accentError">*</span> : null}
          </Text>
          {labelInfo ? (
            <Text variant="bodySm" tone="muted" inline>
              ({labelInfo})
            </Text>
          ) : null}
        </div>
      ) : null}

      <PhoneInputWithCountrySelect
        international
        defaultCountry="US"
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        className={`custom-phone-input ${className}`}
      />

      {rightIcon ? (
        <div className="absolute right-3 top-1/2 flex size-5 -translate-y-1/2 items-center">
          {rightIcon}
        </div>
      ) : null}

      {error ? (
        <div className="mt-1.5 px-3">
          <Text variant="bodySmBold" inline tone="error">
            {error}
          </Text>
        </div>
      ) : null}
    </div>
  );
}
